import React, { FC, ReactNode, useMemo, useState } from 'react';
import { AuthenticationInformation } from '../../../interfaces/AuthenticationInformation';
import AuthenticationContext from '../AuthenticationContext';

export interface AuthenticationProviderProps {
  authenticationInfo?: AuthenticationInformation;
  children: ReactNode;
}

const sessionKey = 'isAuthenticated';

const AuthenticationProvider: FC<AuthenticationProviderProps> = ({ children, authenticationInfo }) => {
  const isAuthenticatedFromSession = sessionStorage.getItem(sessionKey);
  const defaultAuthInfo: AuthenticationInformation = {
    isAuthenticated: isAuthenticatedFromSession === null ? false : isAuthenticatedFromSession === 'true',
    isAuthenticationProcessed: false,
  };
  const [currentAuthInfo, setCurrentAuthInfo] = useState(authenticationInfo || defaultAuthInfo);

  const saveAuthenticationInfo = (values: AuthenticationInformation) => {
    setCurrentAuthInfo(values);
    sessionStorage.setItem(sessionKey, values?.isAuthenticated?.toString() ?? 'false');
  };

  const authContextProviderValue = useMemo(() => ({ authenticationInfo: currentAuthInfo, saveAuthenticationInfo }), [currentAuthInfo]);

  return (
    <AuthenticationContext.Provider value={authContextProviderValue}>
      {children}
    </AuthenticationContext.Provider>
  );
};

export default AuthenticationProvider;
